import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SessionService {
  // currentYear = new Date().getFullYear();
  // startYear = new Date().getFullYear();
   static readonly ADMISSION_START_YEAR = 2027;
  startYear = SessionService.ADMISSION_START_YEAR;
  endYear = this.startYear + 1;
  // AcademicYear=`${this.currentYear}-${this.endYear}`
  AcademicYear=`${this.startYear}-${this.endYear}`

  private getPrimaryDomainPayload(data: any) {
    if (!data) return {};

    if (Array.isArray(data?.List) && data.List.length) {
      return data.List[0] ?? {};
    }

    if (data?.data && typeof data.data === 'object') {
      return data.data;
    }

    if (data?.Data && typeof data.Data === 'object') {
      return data.Data;
    }

    return data;
  }

  private mergeDomainPayload(data: any) {
    const primary = this.getPrimaryDomainPayload(data);
    return {
      ...primary,
      ...data,
      OrganizationId: data?.OrganizationId ?? data?.OrgId ?? primary?.OrganizationId ?? primary?.OrgId ?? null,
      ZoneId: data?.ZoneId ?? primary?.ZoneId ?? null,
      BranchId: data?.BranchId ?? primary?.BranchId ?? null,
      SchoolName: data?.SchoolName ?? primary?.SchoolName ?? '',
      SubDomain: data?.SubDomain ?? primary?.SubDomain ?? '',
      EnabledConvenienceFee:
        data?.EnabledConvenienceFee ?? primary?.EnabledConvenienceFee ?? false,
    };
  }

  setSession(data: any) {
    const normalized = this.mergeDomainPayload(data);

    if (normalized.OrganizationId !== null && normalized.OrganizationId !== undefined) {
      sessionStorage.setItem('OrganizationId', String(normalized.OrganizationId));
    }

    if (normalized.ZoneId !== null && normalized.ZoneId !== undefined) {
      sessionStorage.setItem('ZoneId', String(normalized.ZoneId));
    }

    if (normalized.BranchId !== null && normalized.BranchId !== undefined) {
      sessionStorage.setItem('BranchId', String(normalized.BranchId));
    }

    sessionStorage.setItem('AcademicYear',this.AcademicYear );
    sessionStorage.setItem('SchoolName', normalized.SchoolName ?? '');
    sessionStorage.setItem('SubDomain', normalized.SubDomain ?? '');
    sessionStorage.setItem('EnabledConvenienceFee', String(normalized.EnabledConvenienceFee ?? false));
  }
setDomainDetails(data: any) {
  const normalized = this.mergeDomainPayload(data);
  sessionStorage.setItem('domainDetails', JSON.stringify(normalized));
      sessionStorage.setItem('AcademicYear',this.AcademicYear );
}
get subDomain1() {
  return this.domainDetails?.SubDomain;
}

get isPaymentEnabled() {
  return this.domainDetails?.EnabledPayment;
}

get isConvFeeEnabled1() {
  return this.domainDetails?.EnabledConvenienceFee;
}
get isPublishLink() {
  return this.domainDetails?.IsPublishLink;
}
get domainDetails() {
  const data = sessionStorage.getItem('domainDetails');
  return data ? JSON.parse(data) : null;
}
  get orgId() {
    return sessionStorage.getItem('OrganizationId') ?? this.domainDetails?.OrganizationId ?? this.domainDetails?.OrgId ?? null;
  }

  get zoneId() {
    return sessionStorage.getItem('ZoneId') ?? this.domainDetails?.ZoneId ?? null;
  }

  get branchId() {
    return sessionStorage.getItem('BranchId') ?? this.domainDetails?.BranchId ?? null;
  }

  get academicYear() {
    return sessionStorage.getItem('AcademicYear');
  }
 get schoolName() {
    return sessionStorage.getItem('SchoolName') ?? this.domainDetails?.SchoolName ?? null;
  }

  get reqFrom() {
    return sessionStorage.getItem('ReqFrom');
  }

  get isConvFeeEnabled() {
   return sessionStorage.getItem('EnabledConvenienceFee') ?? this.domainDetails?.EnabledConvenienceFee ?? null;
  }
  get subDomain() {
  return sessionStorage.getItem('SubDomain') ?? this.domainDetails?.SubDomain ?? null;
}

  hasRequiredDomainContext(): boolean {
    return !!(this.orgId && this.zoneId && this.branchId);
  }

  clearAdmissionStateKeepDomainContext() {
    const keepKeys = new Set([
      'OrganizationId',
      'ZoneId',
      'BranchId',
      'AcademicYear',
      'SchoolName',
      'SubDomain',
      'EnabledConvenienceFee',
      'domainDetails',
    ]);

    const keysToRemove: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);
      if (key && !keepKeys.has(key)) {
        keysToRemove.push(key);
      }
    }

    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  }

  clear() {
    sessionStorage.clear();
  }
}
